/* eslint-disable @typescript-eslint/no-unsafe-return */
import { Plugin } from './plugin';
import { LoggerService } from 'rainbow-web-sdk/services/core/logger.service';
import { CallRecorderService } from '../services/call/callRecorder.service';

export class CallRecorderPlugin extends Plugin {
    public static initialize(): CallRecorderPlugin {
        Plugin.initialize();

        if (!window.rainbow.plugins[CallRecorderPlugin.name]) {
            const logger = LoggerService.getInstance();
            logger.info("[CallRecorderPlugin] initialized");
            window.rainbow.plugins[CallRecorderPlugin.name] = new CallRecorderPlugin();
            CallRecorderService.getInstance();
        }
        return window.rainbow.plugins[CallRecorderPlugin.name];
    }

    private constructor() {
        super();
    }
}
